import { classNames } from '@app/utils/classes'

export const getSubmitStyles = (submitPlanCapable: boolean) => {
  return classNames(
    'w-full min-w-[17rem] md:w-auto',
    `rounded font-bold text-base px-8 md:px-12 py-2`,
    submitPlanCapable
      ? 'text-white dark:text-gray-50 bg-blue-800 dark:bg-blue-600 hover:bg-blue-600 dark:hover:text-gray-100 dark:hover:bg-blue-500'
      : 'bg-gray-300 text-gray-800'
  )
}
